<template>
  <div class="file-input">
    <label v-if="label" class="form-label">{{ label }}:</label>
    <div class="form-input p-0" :class="{ error: errors.length }">
      <input ref="file" type="file" :accept="accept" class="hidden" @change="change">
      <div v-if="!value" class="p-2 text-center">
        <button type="button" class="browse" @click="browse">
          {{ text ? text : 'Browse'}}
        </button>
      </div>
      <div v-else class="flex items-center justify-between p-2">
        <div class="flex-1 pr-1">{{ value.name }} <span class="text-grey-dark text-xs">({{ filesize(value.size) }})</span></div>
        <button type="button" class="btn-remove" @click="remove">
          Remove
        </button>
      </div>
    </div>
    <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
  </div>
</template>

<script>
  export default {
    props: {
      value: File,
      label: String,
      accept: String,
      text: String,
      errors: {
        type: Array,
        default: () => [],
      },
    },
    watch: {
      value(value) {
        if (!value) {
          this.$refs.file.value = ''
        }
      },
    },
    methods: {
      filesize(size) {
        var i = Math.floor(Math.log(size) / Math.log(1024))
        return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
      },
      browse() {
        this.$refs.file.click()
      },
      change(e) {
        this.$emit('input', e.target.files[0])
      },
      remove() {
        this.$emit('input', null)
      },
    },
  }
</script>
